<template>
<v-content>
  <v-container v-if="initiated">
    <v-dialog v-model="dialog" max-width="800px">
      <v-card class="spinelab-website-front" v-if="dlgIsHost">
        <v-card-title>
          <h3>URL変更</h3>
        </v-card-title>
        <v-card-text>
          <v-layout row>
            <p>https://</p>
            <v-text-field
              v-model="dlgSubdomain"
              hint="半角英数字の小文字と-(ハイフン)のみご利用いただけます。"
              :error-messages="dlgErrorMessages"
              persistent-hint
              :loading="dlgLoading"
              required>
            </v-text-field>
            <p>.bsj.jp</p>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogue()">
            キャンセル
          </v-btn>
          <v-btn @click="changeSubdomain"
                 :loading="dlgLoading"
                 color="success">
            保存
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <v-card class="spinelab-website-front" v-else>
        <v-card-title>
          <h3>業種変更</h3>
        </v-card-title>
        <v-card-text>
          <v-layout row>
          <v-flex md2>
            <v-subheader>
              業種
            </v-subheader>
          </v-flex>
          <v-flex md4>
            <v-select
              :items="availableIndustries"
              v-model="dlgIndustry"
              item-text="label"
              item-value="id">
            </v-select>
          </v-flex>
          <v-flex md1>
            <v-subheader>
              ＞
            </v-subheader>
          </v-flex>
          <v-flex md4>
            <v-select
              :items="availableSubIndustries"
              v-model="dlgSubIndustry"
              item-text="label"
              item-value="id">
            </v-select>
          </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogue()">
            キャンセル
          </v-btn>
          <v-btn @click="changeIndustry"
                 :loading="dlgLoading"
                 color="success">
            保存
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar app class="spinelab-website-front">
      <v-btn @click="preview()" v-if="editing">
        キャンセル
      </v-btn>
      <template v-else>
        <v-subheader>
          URL:
        </v-subheader>
        <a :href="host" target="_blank">{{host}}</a>
        <v-btn small @click="showHostDialog" v-if="!editing">
          変更
        </v-btn>
        <v-spacer/>
        <v-subheader>
          <span class="small-caption">
            <span class="red--text small-caption-large">実際のサイトは左記のURLでご確認いただけます。</span>
            <br/>
            <span class="small-caption-small">
              ※サイトを表示する端末の画面の大きさに応じてサイトのレイアウトは変わりますのでご了承ください。
            </span>
          </span>
        </v-subheader>
        <v-spacer/>
        <v-subheader>
          業種:
        </v-subheader>
        <template v-if="site.m_industry_id !== null">
          {{industries.m_industries[site.m_industry_id].label}}
          <template v-if="site.m_sub_industry_id !== null">
            ＞ {{industries.m_sub_industries[site.m_sub_industry_id].label}}
          </template>
        </template>
        <v-btn small @click="showIndustryDialog" v-if="!editing">
          変更
        </v-btn>
      </template>
      <v-spacer/>
      <template v-if="editing">
        <v-btn @click="draft()">
          下書き保存
        </v-btn>
        <v-btn @click="save()" color="success">
          保存して公開
        </v-btn>
      </template>
      <v-btn @click="edit()" color="success" v-else>
        編集モード
      </v-btn>
    </v-toolbar>
    <span v-contentbox v-html="editContent" v-if="editing"></span>
    <span v-html="previewContent" v-else></span>
  </v-container>
</v-content>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { snippetsURL } from '@/utils/Requests';

const draftSave = '変更を下書き保存しました';
const publishSave = '変更を保存してサイトを公開しました';
const successChangeHost = 'URLの変更を保存しました';
const successChangeIndustry = '業種の変更を保存しました';

export default {
  name: 'SiteLayout',
  directives: {
    contentbox: {
      bind() {
        // eslint-disable-next-line
        callContentBox(snippetsURL);
      },
      unbind() {
        // eslint-disable-next-line
        uncallContentBox();
      },
    },
  },
  data() {
    return {
      initiated: false,
      editing: false,
      previewContent: '',
      editContent: '',
      snippet: '',
      industries: {},
      dialog: false,
      dlgIsHost: true,
      dlgSubdomain: '',
      dlgIndustry: null,
      dlgSubIndustry: null,
      dlgLoading: false,
      dlgErrorMessages: [],
      availableSubIndustries: [],
    };
  },
  computed: {
    ...mapState({
      requests: state => state.requests,
      site: state => state.site,
      siteId: state => state.siteId,
      siteInfo: state => state.siteInformation,
      page: state => state.site.pages[0],
      host: state => `https://${state.site.host}`,
    }),
    availableIndustries() {
      return Object.keys(this.industries.m_industries).map(
        key => this.industries.m_industries[key],
      );
    },
  },
  watch: {
    dlgIndustry: {
      handler() {
        this.availableSubIndustries = Object.keys(this.industries.m_sub_industries).filter(
          key => this.industries.m_sub_industries[key].m_industry_id === this.dlgIndustry,
        ).map(key => this.industries.m_sub_industries[key]);
        this.dlgSubIndustry = this.availableSubIndustries[0].id;
      },
    },
  },
  methods: {
    ...mapActions(['showAlert', 'setOpenStatus', 'changeHost', 'changeIndustries']),
    async showHostDialog() {
      this.dlgIsHost = true;
      this.dlgLoading = false;
      this.dialog = true;
      this.dlgSubdomain = this.site.host.substring(0, this.site.host.length - 7);
    },
    async showIndustryDialog() {
      this.dlgIsHost = false;
      this.dlgLoading = false;
      this.dialog = true;
      this.dlgIndustry = this.site.m_industry_id;
      this.dlgSubIndustry = this.site.m_sub_industry_id;
    },
    cancelDialogue() {
      this.dialog = false;
    },
    async changeSubdomain() {
      this.dlgLoading = true;
      const result = await this.changeHost({ host: `${this.dlgSubdomain}.bsj.jp` });
      this.dlgLoading = false;
      if (result) {
        this.showAlert({ message: successChangeHost, type: 'success' });
        this.dialog = false;
      } else {
        this.dlgErrorMessages = ['このドメインはすでに使われています'];
      }
    },
    async changeIndustry() {
      this.dlgLoading = true;
      const result = await this.changeIndustries({ industries: {
        m_industry_id: this.dlgIndustry,
        m_sub_industry_id: this.dlgSubIndustry,
      } });
      this.dlgLoading = false;
      if (result) {
        this.showAlert({ message: successChangeIndustry, type: 'success' });
        this.dialog = false;
      } else {
        this.showAlert({ message: undefined, type: 'error' });
        this.dialog = false;
      }
    },
    async edit() {
      const results = await Promise.all([
        this.requests.getEditPage(this.siteId, this.page.id),
      ]);
      if (!results || results.some(x => !x)) {
        this.showAlert({ message: undefined, type: 'alert' });
        return;
      }
      this.editContent = results[0];
      this.editing = true;
    },
    async preview() {
      const content = await this.requests.getPage(this.siteId, this.page.id);
      if (!content) {
        this.showAlert({ message: undefined, type: 'alert' });
        return;
      }
      this.previewContent = content;
      this.editing = false;
    },
    async save() {
      // eslint-disable-next-line
      const html = getContentBoxHTML();
      const result = await this.requests.postEditPage(this.siteId, this.page.id, 'publish', html);
      if (!result) {
        this.showAlert({ message: undefined, type: 'alert' });
        return;
      }
      const statusResult = await this.setOpenStatus(true);
      if (!statusResult) {
        this.showAlert({ message: undefined, type: 'alert' });
        return;
      }
      this.showAlert({ message: publishSave, type: 'success' });
      await this.preview();
    },
    async draft() {
      // eslint-disable-next-line
      const html = getContentBoxHTML();
      const result = await this.requests.postEditPage(this.siteId, this.page.id, 'draft', html);
      if (!result) {
        this.showAlert({ message: undefined, type: 'alert' });
        return;
      }
      this.showAlert({ message: draftSave, type: 'success' });
      await this.preview();
    },
  },
  async created() {
    const result = await Promise.all([
      this.requests.getPage(this.siteId, this.page.id),
      this.requests.getIndustries(),
    ]);
    if (!result[0] || !result[1]) {
      return;
    }
    this.previewContent = result[0];
    this.industries = result[1];
    this.initiated = true;
  },
};
</script>

<style scoped>
.small-caption {
    font-size: 10px !important;
    font-weight: 400;
}

.small-caption .small-caption-large {
    font-size: 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SiteLayout.vue